module.exports = __webpack_public_path__ + "img/alex-cubes.7d20db4f.svg";